import {
  GET_OLD_CHATS,
  CREATE_NEW_CHAT,
  SET_ACTIVE_CHAT,
  DELETE_CHAT_HISTORY,
  CLEAR_CHAT_HISTORY,
  UPADTE_CHAT_LABEL,
  SET_SEARCH_QUERY,
} from '../types/chat.type'

const DEFAULT_HISTORY = (id, title) => {
  return {
    id: id,
    title: title || 'DEFAULT',
    createdAt: new Date().toISOString(),
    active: false,
  }
}

const intialState = {
  activeChat: 1,
  activeChatType: '',
  savedChats: [DEFAULT_HISTORY(1, '')],
  chatLabels: [
    {
      chatId: '',
      chatLabel: '',
    },
  ],
}

const chatHistoryReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_OLD_CHATS: {
      return {
        ...state,
        savedChats: [DEFAULT_HISTORY(1, ''), ...action.payload],
      }
    }
    case CREATE_NEW_CHAT: {
      const chats = state.savedChats
      return {
        ...state,
        activeChat: action.payload[0].id,
        savedChats: [...chats, ...action.payload],
      }
    }
    case SET_ACTIVE_CHAT: {
      return {
        ...state,
        activeChat: action.payload.id,
        activeChatType: action.payload.type,
      }
    }
    case SET_SEARCH_QUERY: {
      return {
        ...state,
        prompt: action.payload.prompt,
        model: action.payload.model,
      }
    }
    case DELETE_CHAT_HISTORY: {
      const { chatId } = action.payload
      const index = state.savedChats.findIndex((chat) => chat.id === chatId)
      return {
        ...state,
        activeChat: state.savedChats.length === 1 ? '1' : index === 0 ? state.savedChats[1].id : state.savedChats[0].id,
        savedChats:
          state.savedChats.length === 1
            ? [DEFAULT_HISTORY(1, '')]
            : state.savedChats.filter((chat) => chat.id !== chatId),
      }
    }
    case UPADTE_CHAT_LABEL: {
      const { chatId, chatLabel } = action.payload
      const existingIndex = state.chatLabels.findIndex((label) => label.chatId === chatId)

      if (existingIndex !== -1) {
        return {
          ...state,
          chatLabels: state.chatLabels.map((label, index) =>
            index === existingIndex ? { ...label, chatLabel } : label
          ),
        }
      } else {
        const newChatLabel = { chatId, chatLabel }
        return {
          ...state,
          chatLabels: [...state.chatLabels, newChatLabel],
        }
      }
    }
    case CLEAR_CHAT_HISTORY: {
      return {
        ...state,
        activeChat: '1',
        savedChats: [DEFAULT_HISTORY(1, '')],
      }
    }
    default:
      return state
  }
}

export default chatHistoryReducer
